import React from 'react'
import PropTypes from 'prop-types'

import './style.css'

class Panel extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      bodyIsOpen: props.defaultOpen
    }
  }
  toggleBody () {
    if (!this.props.disableCollapse) {
      this.setState({
        bodyIsOpen: !this.state.bodyIsOpen
      })
    }
  }
  render () {
    return <div className={`panel ${this.props.panelType} ${this.props.roundedCorners ? 'rounded-corners' : ''}`}>
      <div
        className='panel-heading'
        style={this.props.disableCollapse ? {cursor: 'auto'} : {cursor: 'pointer'}}>
        <div className='row'>
          <div className={`col-xs-${this.props.rightHeader ? 9 : 12} text-left`} onClick={this.toggleBody.bind(this)}>{this.props.heading}</div>
          {this.props.rightHeader
            ? <div className='text-right'>{this.props.rightHeader}</div>
            : null
          }
        </div>
      </div>
      <div className={`panel-content ${this.state.bodyIsOpen ? 'collapse in' : 'collapse'}`} >
        <div className='panel-body' >
          {this.props.children}
        </div>
        {this.props.footer
          ? <div className={`panel-footer ${this.props.panelType} clearfix`}>{this.props.footer}</div>
          : null
        }
      </div>
    </div>
  }
}

Panel.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  rightHeader: PropTypes.object,
  panelType: PropTypes.string,
  footer: PropTypes.object,
  defaultOpen: PropTypes.bool.isRequired,
  children: PropTypes.object.isRequired,
  disableCollapse: PropTypes.bool,
  roundedCorners: PropTypes.bool
}

Panel.defaultProps = {
  panelType: 'panel-default',
  defaultOpen: true,
  disableCollapse: true,
  roundedCorners: true
}

export {Panel}
